import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export const FILTERS = [["pending", "Menunggu"], ["all", "Semua"]];

export const FilterBar = ({ value, onChange }) => (
  <div className="flex gap-2 mb-4">
    {FILTERS.map(([k, l]) => (
      <button key={k} onClick={() => onChange(k)} data-testid={`admin-filter-${k}`}
        className={`px-4 py-2 rounded-lg text-sm font-semibold border transition-colors ${value === k ? "bg-blue-800 text-white border-blue-800" : "bg-white border-slate-200 hover:bg-slate-50"}`}>{l}</button>
    ))}
  </div>
);

export const DecisionButtons = ({ url, id, onDone }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const decide = async (approve) => {
    setBusy(true);
    try {
      await api.post(url, { approve, note: note || null });
      toast.success(approve ? "Disetujui" : "Ditolak");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex flex-wrap gap-2 items-center">
      <Input data-testid={`decision-note-${id}`} className="h-9 w-44 bg-white" placeholder="Catatan" value={note} onChange={(e) => setNote(e.target.value)} />
      <button disabled={busy} onClick={() => decide(true)} data-testid={`approve-${id}`} className="h-9 px-3 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-bold disabled:opacity-60">Setujui</button>
      <button disabled={busy} onClick={() => decide(false)} data-testid={`reject-${id}`} className="h-9 px-3 rounded-lg bg-white border border-red-300 text-red-600 hover:bg-red-50 text-xs font-bold disabled:opacity-60">Tolak</button>
    </div>
  );
};
